 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLHALFTITLE from '@/components/xhtml/halftitle'
 import XHTMLSERIES from '@/components/xhtml/series'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLDEDICATION from '@/components/xhtml/dedication'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLFOREWORD from '@/components/xhtml/foreword'
 import XHTMLPREFACE from '@/components/xhtml/preface'
 import XHTMLHALFTITLE1 from '@/components/xhtml/halftitle1'
 import XHTMLINTRODUCTION from '@/components/xhtml/introduction'
 import XHTMLPART1 from '@/components/xhtml/part1'
 import XHTMLCHAPTER1 from '@/components/xhtml/chapter1'
 import XHTMLCHAPTER2 from '@/components/xhtml/chapter2'
 import XHTMLCHAPTER3 from '@/components/xhtml/chapter3'
 import XHTMLCHAPTER4 from '@/components/xhtml/chapter4'
 import XHTMLCHAPTER5 from '@/components/xhtml/chapter5'
 import XHTMLPART2 from '@/components/xhtml/part2'
 import XHTMLCHAPTER6 from '@/components/xhtml/chapter6'
 import XHTMLCHAPTER7 from '@/components/xhtml/chapter7'
 import XHTMLCHAPTER8 from '@/components/xhtml/chapter8'
 import XHTMLCHAPTER9 from '@/components/xhtml/chapter9'
 import XHTMLPART3 from '@/components/xhtml/part3'
 import XHTMLCHAPTER10 from '@/components/xhtml/chapter10'
 import XHTMLCHAPTER11 from '@/components/xhtml/chapter11'
 import XHTMLCHAPTER12 from '@/components/xhtml/chapter12'
 import XHTMLPART4 from '@/components/xhtml/part4'
 import XHTMLCHAPTER13 from '@/components/xhtml/chapter13'
 import XHTMLCHAPTER14 from '@/components/xhtml/chapter14'
 import XHTMLCHAPTER15 from '@/components/xhtml/chapter15'
 import XHTMLCHAPTER16 from '@/components/xhtml/chapter16'
 import XHTMLCHAPTER17 from '@/components/xhtml/chapter17'
 import XHTMLCHAPTER18 from '@/components/xhtml/chapter18'
 import XHTMLCHAPTER19 from '@/components/xhtml/chapter19'
 import XHTMLCHAPTER20 from '@/components/xhtml/chapter20'
 import XHTMLCHAPTER21 from '@/components/xhtml/chapter21'
 import XHTMLCHAPTER22 from '@/components/xhtml/chapter22'
 import XHTMLCHAPTER23 from '@/components/xhtml/chapter23'
 import XHTMLCHAPTER24 from '@/components/xhtml/chapter24'
 import XHTMLPOSTLUDE from '@/components/xhtml/postlude'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLPHOTO1 from '@/components/xhtml/photo1'
 import XHTMLPHOTO2 from '@/components/xhtml/photo2'
 import XHTMLPHOTO3 from '@/components/xhtml/photo3'
 import XHTMLPHOTO4 from '@/components/xhtml/photo4'
 import XHTMLPHOTO5 from '@/components/xhtml/photo5'
 import XHTMLPHOTO6 from '@/components/xhtml/photo6'
 import XHTMLPHOTO7 from '@/components/xhtml/photo7'
 import XHTMLPHOTO8 from '@/components/xhtml/photo8'
 import XHTMLPHOTO9 from '@/components/xhtml/photo9'
 import XHTMLPHOTO10 from '@/components/xhtml/photo10'
 import XHTMLPHOTO11 from '@/components/xhtml/photo11'
 import XHTMLPHOTO12 from '@/components/xhtml/photo12'
 import XHTMLPHOTO13 from '@/components/xhtml/photo13'
 import XHTMLPHOTO14 from '@/components/xhtml/photo14'
 import XHTMLPHOTO15 from '@/components/xhtml/photo15'
 import XHTMLPHOTO16 from '@/components/xhtml/photo16'
 import XHTMLPHOTO17 from '@/components/xhtml/photo17'
 import XHTMLPHOTO18 from '@/components/xhtml/photo18'
 import XHTMLPHOTO19 from '@/components/xhtml/photo19'
 import XHTMLPHOTO20 from '@/components/xhtml/photo20'
 import XHTMLPHOTO21 from '@/components/xhtml/photo21'
 import XHTMLPHOTO22 from '@/components/xhtml/photo22'
 import XHTMLPHOTO23 from '@/components/xhtml/photo23'
 import XHTMLACKNOWLEDGMENTS from '@/components/xhtml/acknowledgments'
 import XHTMLNOTES from '@/components/xhtml/notes'
 import XHTMLBIBLIOGRAPHY from '@/components/xhtml/bibliography'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLCREDITS from '@/components/xhtml/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/foreword",
 			"name" : "xhtml/foreword",
 			"component" : XHTMLFOREWORD
 		},
 		{
 			"path" : "/xhtml/preface",
 			"name" : "xhtml/preface",
 			"component" : XHTMLPREFACE
 		},
 		{
 			"path" : "/xhtml/halftitle1",
 			"name" : "xhtml/halftitle1",
 			"component" : XHTMLHALFTITLE1
 		},
 		{
 			"path" : "/xhtml/introduction",
 			"name" : "xhtml/introduction",
 			"component" : XHTMLINTRODUCTION
 		},
 		{
 			"path" : "/xhtml/part1",
 			"name" : "xhtml/part1",
 			"component" : XHTMLPART1
 		},
 		{
 			"path" : "/xhtml/chapter1",
 			"name" : "xhtml/chapter1",
 			"component" : XHTMLCHAPTER1
 		},
 		{
 			"path" : "/xhtml/chapter2",
 			"name" : "xhtml/chapter2",
 			"component" : XHTMLCHAPTER2
 		},
 		{
 			"path" : "/xhtml/chapter3",
 			"name" : "xhtml/chapter3",
 			"component" : XHTMLCHAPTER3
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js